import { render, staticRenderFns } from "./editMammal.vue?vue&type=template&id=7c1af50a&"
import script from "./editMammal.vue?vue&type=script&lang=js&"
export * from "./editMammal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports